import { com } from '@eidu/web'
import { useQuery } from '@tanstack/react-query'
import listVersions, { VersionRecord } from '../../../../../io/api/entity/data/listVersions'
import EntityId = com.eidu.entity.EntityId

type UseVersionsResult = {
  records: VersionRecord[] | undefined
  loading: boolean
  error: Error | null
}

export const versionsQueryKey = (entityId: EntityId) => ['entityVersions', entityId.toString()]

const useVersions = (entityId: EntityId): UseVersionsResult => {
  const query = useQuery({
    queryKey: versionsQueryKey(entityId),
    queryFn: () => listVersions({ id: entityId }),
  })

  return { records: query.data, loading: query.isLoading, error: query.error }
}

export default useVersions
